import { ActionType } from "./../types/store-types.d";

export enum CollaborationStatus {
    Pending = "PENDING",
    Approved = "APPROVED",
}

export enum CollaboratorRole {
    Owner = "OWNER",
    Editor = "EDITOR",
    Viewer = "VIEWER",
}

export interface ICollaborator {
    id: string;
    email: string;
    role: CollaboratorRole;
    status: CollaborationStatus;
}

export enum CollaboratorTypes {
    None,
    Input,
    Choices,
    DateAndTime,
    Texts,
    Advanced,
}

/* - Data Types - */

export interface AddCollaboratorData {
    email: ICollaborator["email"];
    role: CollaboratorRole;
}

export interface AddCollaboratorWithTempIdData {
    id: ICollaborator["id"];
    email: ICollaborator["email"];
    role: CollaboratorRole;
    status: CollaborationStatus;
}

export interface DeleteCollaboratorData {
    id: ICollaborator["id"];
}

export interface ChangeCollaboratorRoleData {
    id: ICollaborator["id"];
    newRole: CollaboratorRole;
}

/* - State - */

export interface CollaboratorsState {
    owner: ICollaborator;
    list: ICollaborator[];
}

/* - Action Types - */

export enum CollaboratorsActionTypes {
    ADD = "COLLABORATORS.ADD",
    DELETE = "COLLABORATORS.DELETE",
    ADD_WITH_TEMP_ID = "COLLABORATORS.ADD_WITH_TEMP_ID",
    CHANGE_ROLE = "CHANGE_ROLE",
}

/* - Action Interfaces  - */
// TODO: Update typing after merge

export type IAddCollaboratorAction = ActionType<CollaboratorsActionTypes.ADD, AddCollaboratorData>;

export type IDeleteCollaboratorAction = ActionType<CollaboratorsActionTypes.DELETE, DeleteCollaboratorData>;

export type IAddCollaboratorWithTempIdAction = ActionType<
    CollaboratorsActionTypes.ADD_WITH_TEMP_ID,
    AddCollaboratorWithTempIdData
>;

export type IChangeCollaboratorRoleAction = ActionType<
    CollaboratorsActionTypes.CHANGE_ROLE,
    ChangeCollaboratorRoleData
>;
